import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export const getCountries = () => axios.get(API_URLS.COUNTRIES, {});
